// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import uuidv4 from 'uuid/v4';
import { withStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';

import menuIcon from '../../../images/main-iosMenu.png';
import styles from './styles';

const MobileMenu = ({ leftMenu, classes }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const buttonProps = (handler) => {
    return {
      role: 'button',
      tabIndex: 0,
      onClick: handler,
      onKeyDown: event => ((event.keycode === 13) ? handler(event) : null),
    };
  };
  return (
    <div>
      <div
        aria-controls={'mobile-menu'}
        aria-haspopup={'true'}
        {...buttonProps(handleClick)}
        className={classes.menuIconLink}
      >
        <img src={menuIcon} alt={'menu icon'} style={{ width: 18, height: 12 }} />
      </div>
      <Menu
        id={'mobile-menu'}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {leftMenu.map(option => (
          <MenuItem key={uuidv4()} onClick={handleClose}>
            <Link to={option.link} className={classes.link}>{option.label}</Link>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

MobileMenu.propTypes = {
  leftMenu: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  })),
  classes: PropTypes.object,
};

MobileMenu.defaultProps = {
  leftMenu: [{
    label: 'no links',
    link: '',
  }],
  classes: {},
};

export default withStyles(styles)(MobileMenu);
